import React from 'react';
import { Navigate } from '@tanstack/react-location';
import { useAuth } from '../hooks/useAuth';

/**
 * Page guard (replaces Auth0's withAuthenticationRequired). Sends signed-out users to /login.
 * AuthProvider applies the same rule app-wide; this keeps each protected page explicit.
 */
export function withAuthenticationRequired<P extends object>(
  Component: React.ComponentType<P>,
  // Accepted for call-site compatibility with the old Auth0 HOC; unused.
  _options?: unknown
): React.FC<P> {
  return function WithAuthenticationRequired(props: P) {
    const { isAuthenticated } = useAuth();
    if (!isAuthenticated) {
      return <Navigate to="/login" replace />;
    }
    return <Component {...props} />;
  };
}

export default withAuthenticationRequired;
